module.exports = __webpack_public_path__ + "img/usp_icon1.66bde9d6.svg";